import React, { useEffect, useState } from "react";
import "./EmployeeStatus.css";

export default function EmployeeStatus() {
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [statusFilter, setStatusFilter] = useState("All");

  useEffect(() => {
    fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/get_employee_status.php")
      .then((res) => res.json())
      .then((data) => {
        setEmployees(data);
        setFilteredEmployees(data);
      })
      .catch((err) => console.error(err));
  }, []);

  // Handle Status Change
  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value;
    setStatusFilter(selectedStatus);

    if (selectedStatus === "All") {
      setFilteredEmployees(employees);
    } else {
      setFilteredEmployees(
        employees.filter(
          (emp) => (emp.work_status || "Idle") === selectedStatus
        )
      );
    }
  };

  // Extract unique statuses from data
  const uniqueStatuses = ["All", ...new Set(employees.map(emp => emp.work_status || "Idle"))];

  return (
    <div className="container">
      <h1>Employee Work Status</h1>

      {/* Status Filter Dropdown */}
      <div className="filter-section">
        <label>Status: </label>
        <select value={statusFilter} onChange={handleStatusChange}>
          {uniqueStatuses.map((status, index) => (
            <option key={index} value={status}>
              {status}
            </option>
          ))}
        </select>
      </div>

      <table>
        <thead>
          <tr>
            <th>Employee</th>
            <th>Phone</th>
            <th>Department</th>
            <th>Designation</th>
            <th>Latest Task</th>
            <th>Status</th>
            <th>Assigned</th>
            <th>Started</th>
            <th>Completed</th>
          </tr>
        </thead>
        <tbody>
          {filteredEmployees.map((emp) => (
            <tr key={emp.employee_id}>
              <td>{emp.full_name}</td>
              <td>{emp.phone_number}</td>
              <td>{emp.department}</td>
              <td>{emp.designation}</td>
              <td>{emp.work_title || "No Task"}</td>
              <td>{emp.work_status || "Idle"}</td>
              <td>{emp.assign_date || "-"}</td>
              <td>{emp.start_time || "-"}</td>
              <td>{emp.end_time || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
